// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown.dropdown--power[data-v-023f3502]{border:2px solid #ea60af;margin-bottom:0}.select-holder[data-v-023f3502]{position:relative}.select-holder select[data-v-023f3502]{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0}.select-holder input[data-v-023f3502]{text-align:center;width:100%;pointer-events:none;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}", ""]);
// Exports
module.exports = exports;
